module.exports = __webpack_public_path__ + "img/premiation-10-viagem-punta-cana-hyundai-hb20.525c5fd3.png";